import { Box, Paper, Typography } from "@mui/material";
import AppButton from "../app-button/AppButton"; // adjust path
import Iconify from "../iconify/Iconify";

function TableEmptyState({
  icon = "mdi:folder-outline",
  title = "No records available",
  description = "There are currently no records in this table. You can add new entries to get started.",
  buttonLabel, // optional
  onButtonClick, // optional
  sx = {},
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        py: 2,
        textAlign: "center",
        borderRadius: 2,
        bgcolor: "#fafafa",
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 60,
          height: 60,
          borderRadius: "50%",
          bgcolor: "action.hover",
          mb: 2,
        }}
      >
        <Iconify icon={icon} width={32} height={32} color="#888" />
      </Box>

      <Typography variant="h6" sx={{ mb: 1 }}>
        {title}
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {description}
      </Typography>

      {buttonLabel && onButtonClick && (
        <AppButton
          onClick={onButtonClick}
          variant="contained"
          startIcon={<Iconify icon="eva:plus-fill" />}
        >
          {buttonLabel}
        </AppButton>
      )}
    </Paper>
  );
}

export default TableEmptyState;
